import React, { useEffect, useState, useRef } from "react";
import {
  Link,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import credithelpimg from "../assets/img/credithelp.png";
import "../assets/style/gtos.css";
const grades = {
  EX: 10.0,
  AA: 9.0,
  AB: 8.5,
  BB: 8.0,
  BC: 7.5,
  CC: 7.0,
  CD: 6.5,
  DD: 6.0,
  DE: 5.5,
  EE: 5.0,
};

function GradeToSgpa() {
  const [numSubjects, setNumSubjects] = useState();
  const [subjects, setSubjects] = useState([]);
  const [hasSub, setHasSub] = useState(false);

  const handleNumSubjectsChange = (e) => {
    const num = parseInt(e.target.value);
    setNumSubjects(num);
    if (num > 0) {
      setHasSub(true);
    } else {
      setHasSub(false);
    }

    setSubjects(
      Array.from({ length: num }, (_, i) => ({
        subNo: i + 1,
        credit: 0,
        grade: "EX",
      }))
    );
  };

  const handleCreditChange = (subNo, e) => {
    const credit = parseInt(e.target.value);
    setSubjects(
      subjects.map((subject) =>
        subject.subNo === subNo ? { ...subject, credit } : subject
      )
    );
  };

  const handleGradeChange = (subNo, e) => {
    const grade = e.target.value;
    setSubjects(
      subjects.map((subject) =>
        subject.subNo === subNo ? { ...subject, grade } : subject
      )
    );
  };

  const calculateSGPA = () => {
    const totalCredit = subjects.reduce(
      (acc, subject) => acc + subject.credit,
      0
    );
    const gradePoints = subjects.reduce(
      (acc, subject) => acc + subject.credit * grades[subject.grade],
      0
    );
    //round
    // return totalCredit !== 0 ? Math.round(gradePoints) / totalCredit : 0;
    return totalCredit !== 0 ? gradePoints / totalCredit : 0;
  };

  // const calculateSGPA = () => {
  //     // Check if any subject has an "FF" grade
  //     const hasFailGrade = subjects.some((subject) => subject.grade === "FF");

  //     // If any subject has an "FF" grade, return "Fail"
  //     if (hasFailGrade) {
  //       return "Fail";
  //     }

  //     // Calculate SGPA as before if there are no "FF" grades
  //     const totalCredit = subjects.reduce((acc, subject) => acc + subject.credit, 0);
  //     const totalGradeCredit = subjects.reduce((acc, subject) => acc + (subject.credit * grades[subject.grade]), 0);
  //     return totalCredit !== 0 ? totalGradeCredit / totalCredit : 0;
  //   };

  return (
    <div className="container mt-2 mb-5">
      <h3>
        GRADE to SGPA converter{" "}
        <span
          style={{ color: "blue", cursor: "pointer", fontSize: "16px" }}
          id="_help_"
        >
          How to Use?
        </span>
      </h3>
      <hr />
      <div class="input-group mb-3" id="inputgroup">
        <span class="input-group-text bg-uni">
          <label htmlFor="ns" style={{ cursor: "pointer" }}>
            Total no. of subjects
          </label>
        </span>
        <input
          id="ns"
          class="form-control"
          min="0"
          max="20"
          placeholder="e.g. 7 (except audit subjects)"
          type="number"
          value={numSubjects}
          onChange={handleNumSubjectsChange}
        />
      </div>
      {hasSub && (
        <>
          <table className="table">
            <thead>
              <tr>
                <th id="sub_no">Subject No</th>
                <th id="credit">
                  Credit Allotted{" "}
                  <Link
                    data-bs-toggle="modal"
                    data-bs-target="#helpModal"
                    id="needhelp"
                  >
                    Need help?
                  </Link>{" "}
                </th>
                <th id="grade">Grade</th>
              </tr>
            </thead>
            <tbody>
              {subjects.map((subject) => (
                <tr key={subject.subNo}>
                  <td>Subject {subject.subNo}</td>
                  <td>
                    <input
                      className="form-control form-control-sm "
                      type="number"
                      value={subject.credit}
                      onChange={(e) => handleCreditChange(subject.subNo, e)}
                    />
                  </td>
                  <td>
                    <select
                      className="form-select form-select-sm "
                      value={subject.grade}
                      onChange={(e) => handleGradeChange(subject.subNo, e)}
                    >
                      {Object.keys(grades).map((grade) => (
                        <option key={grade} value={grade}>
                          {grade}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <button
            id="btn-cal-sgpa"
            className="btn btn-primary w-100"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            Calculate SGPA
          </button>
        </>
      )}

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                Your SGPA: {calculateSGPA().toFixed(2)}
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              {/* <div
                class="alert alert-warning alert-dismissible fade show"
                role="alert"
              >
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
                <h6 class="alert-heading">Note</h6>
                <p>
                  Note: 
                </p>
              </div> */}
              {/* SGPA:<b>{` ${calculateSGPA().toFixed(2)}`}</b>
        <br/>
        Percentage:<b>{` ${ calculateSGPA().toFixed(2)<0 ? (((calculateSGPA().toFixed(2))-0.5)*10).toFixed(2) :0 } %`}</b>
        <br/>
        Grade Points:<b>{` ${subjects.reduce((acc, subject) => acc + (subject.credit * grades[subject.grade]), 0)}`}</b>
        <br/>
        Total Credits:<b>{` ${subjects.reduce((acc, subject) => acc + subject.credit, 0)}`}</b>
         */}

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Total Credits</th>
                    <th>Grade Points</th>
                    <th>SGPA</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {subjects.reduce(
                        (acc, subject) => acc + subject.credit,
                        0
                      )}
                    </td>
                    <td>
                      {subjects.reduce(
                        (acc, subject) =>
                          acc + subject.credit * grades[subject.grade],
                        0
                      )}
                    </td>
                    <td>{calculateSGPA().toFixed(2)}</td>
                    <td>
                      {calculateSGPA().toFixed(2) < 0
                        ? ((calculateSGPA().toFixed(2) - 0.5) * 10).toFixed(2)
                        : 0}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Subject</th>
                    <th>Credits</th>
                    <th>Grade</th>
                    <th>Grade Points</th>
                  </tr>
                </thead>
                <tbody>
                  {subjects.map((subject) => (
                    <tr key={subject.subNo}>
                      <td>Subject {subject.subNo}</td>
                      <td>
                        {subject.credit}
                     
                      </td>
                      <td>
                        {subject.grade}
                          
                      </td>
                      <td>
                        {grades[subject.grade]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                data-bs-dismiss="modal"
                class="btn btn-primary"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal  modal-dialog-scrollable fade"
        id="helpModal"
        tabindex="-1"
        aria-labelledby="helpModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="helpModalLabel">
                Need help finding the credit allotted to a subject?
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              You can easily check the credits in your syllabus. Here's an
              example to guide you: Understanding the credit allocation for each
              subject is crucial. By referring to your syllabus, you can easily
              find the specific credit allotted to a subject. For instance, if
              your syllabus states that a particular subject is worth 4 credits,
              it means that the subject carries a certain weightage in your
              academic curriculum. This information is essential for calculating
              your SGPA and CGPA accurately. If you're unsure about how to
              locate this information in your syllabus, we're here to help!
              <img width={"100%"} src={credithelpimg} alt="" />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                data-bs-dismiss="modal"
                class="btn btn-primary"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
      <TourGuide nosub={numSubjects} />
    </div>
  );
}

export default GradeToSgpa;

function TourGuide(props) {
  const location = useLocation();
  const driverObjRef = useRef(null);

  useEffect(() => {
    const _help_ = document.getElementById("_help_");

    const driverObj = driver({
      // showProgress: true,
      allowClose: true,
      // overlayColor: '#47d3ceab',
      popoverClass: "driverjs-theme",
      showButtons: ["next", "previous", "close"],

      steps: [
        {
          element: "#inputgroup",
          popover: {
            title: "Quick Start Guide",
            description: "Learn how to use Grade to  SGPA converter...",
            side: "right",
            align: "center",
          },
        },
        {
          element: "#ns",
          popover: {
            title: "No of subjects",
            description:
              "Enter number of subjects you have in semester</br> <b>Note</b>: <i>to get help for next step first enter no. of subjects in input box.</i>",
            side: "right",
            align: "center",
          },
        },
        {
          element: "#sub_no",
          popover: {
            title: "Subject No",
            description: "This column indicates subject Number.",
            side: "right",
            align: "center",
          },
        },
        {
          element: "#credit",
          popover: {
            title: "Credit Alloted",
            description:
              "In this column you need to Enter credit alloted to individual subject in input box of each row.",
            side: "right",
            align: "center",
          },
        },
        {
          element: "#needhelp",
          popover: {
            title: "Need help finding the credit allotted to a subject?",
            description:
              "click on <b>Need Help?</b> link this will guide you to find credit alloted for subject.</br><b>Note:</b><i>Read carefully all the steps to avoid mistakes.</i>",
            side: "right",
            align: "center",
          },
        },
        {
          element: "#grade",
          popover: {
            title: "Grade",
            description:
              "In this column you need to select grade for individual subject from dropdown.",
            side: "right",
            align: "center",
          },
        },
        {
          element: "#btn-cal-sgpa",
          popover: {
            title: "Click on calculate SGPA button",
            description:
              "after putting credit & Grades in above table, then click on <b>Calculate SGPA</b> Button.</br><i>Congratulation! You have successfully calculated your SGPA. Happy Learning! Thank You!</i>",
            side: "right",
            align: "center",
          },
        },
      ],

      onDestroyStarted: () => {
        if (!driverObj.hasNextStep()) {
          if (localStorage.isnewusergrade) {
            localStorage.setItem("isnewusergrade", "false");
          }

          driverObj.destroy();
        }
      },

      onCloseClick: () => {
        if (Number(localStorage.countsclicksgpa) >= 2) {
          if (localStorage.isnewusergrade) {
            localStorage.setItem("isnewusergrade", "false");
          }
        }
        driverObj.destroy();

        localStorage.setItem(
          "countsclicksgpa",
          Number(localStorage.countsclicksgpa) + 1
        );
        console.log(Number(localStorage.countsclicksgpa));
      },
    });
    driverObjRef.current = driverObj;

    if (!localStorage.isnewusergrade) {
      localStorage.setItem("isnewusergrade", "true");
    }

    if (!localStorage.countsclicksgpa) {
      localStorage.setItem("countsclicksgpa", "0");
    }

    if (localStorage.isnewusergrade == "true") {
      driverObj.drive();
    }

    _help_.addEventListener("click", () => {
      driverObj.drive();
    });

    return () => {
      if (driverObjRef.current) {
        driverObjRef.current.destroy();
      }
    };
  }, [location.pathname]);

  return <></>;
}
